import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { toIsoFromDateTimeParts } from '@/common/utils/dateUtils';
import { unFormatUnknownUnit } from '@/common/utils/unFormatters';
import { ManualEntryProposalsAcceptValidationSchema } from '../../../../schemas/forwardings/establishmentChoice/manualEntryProposals/manualEntryProposalsAccept.schema';

interface UseMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAcceptProps {
  establishmentChoiceEntryId: string;
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse, ManualEntryProposalsAcceptValidationSchema>, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept = ({
  establishmentChoiceEntryId,
  options,
}: UseMaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAcceptProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept'],
    mutationFn: (form) => {
      const startAt = toIsoFromDateTimeParts(form.start_at_date, form.start_at_time);

      const payload = {
        start_at: startAt,
        deadline_to_complete_in_days: unFormatUnknownUnit(form.deadline_to_complete_in_days),
      }

      return privateAxios.put(`/maintenance/establishment_choice/manual_entry_proposals/${establishmentChoiceEntryId}/establishment_accept`, {
        directive_proposal_content_attributes: payload,
      });
    },
    ...options
  });
}
